<template>
  <div class="modal_container" @click="close">
    <div class="image" :style="`background-image: url(${actualImage.url})`" ></div>
    <a v-if="$mq==='small'" class="info">Dotknij gdziekolwiek aby zamknąć podgląd.</a>
    <a v-else class="info">Kliknij gdziekolwiek aby zamknąć podgląd.</a>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  name: 'modalImage',
  computed:{
    ...mapState({
      actualImage: state => state.gridGallery.actualImage
    })
  },
  methods:{
    ...mapActions(['fullImage']),
    close(){
        this.fullImage();
    }
  }
}
</script>

<style scoped lang="scss">
.info{
  position: absolute;
  bottom: 12px;
  left: 0;
  width: 100%;
  text-align: center;
}
  .modal_container{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.589);
    z-index: 50;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .image{
    width: 100%;
    height: 100%;
    background-size: 70%;
    background-repeat: no-repeat;
    background-position: center;
    // box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
  }

</style>